function showChat() {
  const chatbotElement = document.querySelector('.MuiButtonBase-root.MuiAccordionSummary-root');

  if (chatbotElement) {
    chatbotElement.click();
  }
}
function qs (selector, searchIn) {
  return searchIn ? searchIn.querySelector(selector) : document.querySelector(selector)
}
function qsa (selector, searchIn) {
  return searchIn ? searchIn.querySelectorAll(selector) : document.querySelectorAll(selector)
}

function qsaEach (selector, searchIn, func) {
  let arr = searchIn ? searchIn.querySelectorAll(selector) : document.querySelectorAll(selector);
  [...arr].forEach(func)
}  

window.onload = () => {

  function updateHeaderHeight() {
    // Select the header element
    const header = document.querySelector('header.header');
    if (header) {
      // Get the height of the header
      const height = header.offsetHeight;
      // Update the CSS variable --header-height with the new height
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }

  // Run once on initial load
  updateHeaderHeight();

  // Optional: Adjust the header height dynamically on window resize
  window.addEventListener('resize', updateHeaderHeight);

};

document.addEventListener("DOMContentLoaded", function() {

  // common
  qs('.header__cart').onclick = () => {
    if(!qs('.header__cart').classList.contains('cart-templ')) {
      qs('.cart-fixed').classList.add('active');
      qs('#shopify-section-header').classList.add('topmost-layer');
    }
  }
  window.onclick = (e) => {
  
    const filters_sidebar = qs('.collection-content .grid__item--sidebar');

    if(filters_sidebar && filters_sidebar.classList.contains('active') && !e.target.closest('.facets-container') && !e.target.closest('.mobile-filter')) {
      filters_sidebar.classList.remove('active');
    }


    if(qs('.cart-fixed') && qs('.cart-fixed').classList.contains('active') &&
       !e.target.closest('.cart-fixed-wrap') &&
       !e.target.closest('.header__cart') ||
       e.target.closest('.cart-close')) {
      qs('.cart-fixed').classList.remove('active');
      qs('#shopify-section-header').classList.remove('topmost-layer');

    }
    
    if(qs('.header__bottom').classList.contains('active') && !e.target.closest('.header__bottom-wrap') && !e.target.closest('.header__hamb')) {
      qs('.header__bottom').classList.remove('active');
      qs('#shopify-section-header').classList.remove('topmost-layer');
    }
    

    if(e.target.closest('.product-card [data-notify-prod]')) {
      localStorage.setItem('notify', 'true');
    }
  }

  let hamb = qs('.header__hamb'),
      menu = qs('.header__bottom'),
      close = qs('.header__close'),
      back = qs('.header__back');

  hamb.onclick = () => {
    menu.classList.add('active');
    qs('#shopify-section-header').classList.add('topmost-layer');
  }
  close.onclick = () => {
    menu.classList.remove('active');
    qs('#shopify-section-header').classList.remove('topmost-layer');
  }

  qsa('.header__link').forEach(el => {
    el.onclick = (e) => {
      if(window.innerWidth < 1024 && el.classList.contains('meganav-enabled')) {
        e.preventDefault();
        el.nextElementSibling.classList.add('active');
        back.classList.add('active');
      }
    }
  })

  back.onclick = (e) => {
    qs('.header__meganav.active').classList.remove('active');
    back.classList.remove('active');
  }

  let subnavs = qsa('.header__sub-link, .collapsible-trigger');

  subnavs.forEach(el => {
    el.onclick = (e) => {
      // if(window.innerWidth < 1024) {
        let answer = el.nextElementSibling;
        if(el.classList.contains('active')) {
          el.classList.remove('active');
          answer.style.height = '0px';
        } else {
          el.classList.add('active');
          answer.style.height = answer.scrollHeight + 'px';
        }
      // }
    };
  })


  // index
  if(qs('.newsletter__inputs button')) {
    qs('.newsletter__inputs button').onclick = (e) => {
      e.preventDefault();
      
      let name = qs('#signup_name').value;
      let email = qs('#signup_email').value;
      
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": "YhnTXh",
          "$fields": "name, language",
          "email": email,
          "name": name,
          "language": Shopify.locale.toUpperCase()
        }
      }
    
      $.ajax(settings).done(function (response) {
        console.log(response);
        document.querySelector('.newsletter__inputs').style.display = 'none';
        document.querySelector('.newsletter__success').style.display = 'block';
      }); 
    }
  }
 

  // product

  if(document.body.classList.contains('template-product')) {
    

    if(localStorage.getItem('notify') == 'true') {
      let form = qs('.product-single__form');
      setTimeout(() => {
        localStorage.removeItem('notify');
        qs('.product-form-block').classList.add('notify-active');
        scrollTo(offsetTop(form) - window.innerHeight / 2 + form.clientHeight / 2);
      }, 1000)
    }

    if(window.innerWidth < 1024) {
      qs('.product-form-block').appendChild(qs('.consult-wrapper'));
  
      qs('.copy-qty-minus').onclick = () => qs('.form--original .js-qty__adjust--minus').click();
      qs('.copy-qty-plus').onclick = () => qs('.form--original .js-qty__adjust--plus').click();
  
      qs('.form--original .js-qty__adjust--minus').onclick = (e) => qs('.copy-qty-input').value = qs('.qty--original').value
      qs('.form--original .js-qty__adjust--plus').onclick = (e) => qs('.copy-qty-input').value = qs('.qty--original').value
  
      qs('.copy-cart-btn').onclick = () => qs('.form--original .btn.add-to-cart').click();

    }
    const customDiscountData = JSON.parse(document.querySelector('[data-custom-discount-data]').textContent);
    if (Shopify.locale === 'en' || window.innerWidth < 1024 || customDiscountData.show_discount == true) {
      const targetNode = qs('.product-description');
      const config = { childList: true };

      const callback = function(mutationsList, observer) {
        for(const mutation of mutationsList) {
          if (mutation.addedNodes[0].classList.contains('cbb-frequently-bought-container')) {
            observer.disconnect();
            if(customDiscountData.show_discount == true) {
              hideProductPrices();
              // Додаємо слухачі на зміну варіантів
              setupPriceHidingOnVariantChange();
            }

            setTimeout(() => {
              if (Shopify.locale === 'en') {
                translateFBTText();
              }
              if(window.innerWidth < 1024) {
                qs('.product-full-width').appendChild(qs('.cbb-frequently-bought-container'));
                qs('.cbb-frequently-bought-container').appendChild(qs('.cbb-frequently-bought-form'));
              }

            }, 300)
          }
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);

      function translateFBTText () {
        const translations = window.frequently_bought_together;

        document.querySelector('.cbb-frequently-bought-title').textContent = translations.title;
        document.querySelector('.cbb-frequently-bought-total-price-text').textContent = translations.price_total;
        document.querySelector('.cbb-frequently-bought-this-item-label').textContent = translations.this_product;
        document.querySelector('.cbb-frequently-bought-add-button .translatable').textContent = translations.add_to_cart;

        const product1Handle = document.querySelector('.product-section')?.dataset.productHandle;
        const product2Link = document.querySelector('.cbb-frequently-bought-selector-link')?.href;

        if (product1Handle && product2Link) {
            const product1HandlePath = '/en/products/' + product1Handle;
            const product2HandlePath = new URL(product2Link).pathname;

            // console.warn('Fetching product titles for frequently bought together section...');
            // console.warn(product1HandlePath);
            // console.warn(product2HandlePath);
            

            fetch(product1HandlePath + '?section_id=fbt-product-translations')
                .then(response => response.text())
                .then(html => {
                    const product1Title = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section')?.textContent;
                    const product1TitleElement = document.querySelector('.cbb-frequently-bought-this-item-label').nextElementSibling;
                    if (product1Title && product1TitleElement) {
                        // console.warn(product1Title);
                        product1TitleElement.innerHTML = product1Title;
                    }
                })
                .catch(error => console.warn('Error fetching product 1 title:', error));

            fetch(product2HandlePath + '?section_id=fbt-product-translations')
                .then(response => response.text())
                .then(html => {
                    const product2Title = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section')?.textContent;
                    const product2TitleElement = document.querySelectorAll('.cbb-frequently-bought-selector-label-name')[1];
                    if (product2Title && product2TitleElement) {
                        // console.warn(product2Title);
                        product2TitleElement.innerHTML = product2Title;
                    }
                })
                .catch(error => console.warn('Error fetching product 2 title:', error));
        }
      }
      
      function hideProductPrices() {
        // Приховуємо загальну ціну
        const totalPriceBox = qs('.cbb-frequently-bought-total-price-box');
        if (totalPriceBox) {
          totalPriceBox.style.display = 'none';
        }
        
        // Приховуємо ціну ТІЛЬКИ першого продукту (поточного на сторінці)
        const firstProductPrice = qs('.cbb-frequently-bought-selector-label-regular-price');
        if (firstProductPrice) {
          firstProductPrice.style.display = 'none';
        }
      }

      function setupPriceHidingOnVariantChange() {
        // Додаємо слухачі на всі селекти варіантів
        const variantSelects = document.querySelectorAll('.cbb-recommendations-variant-select');
        variantSelects.forEach(select => {
          select.addEventListener('change', () => {
            // Невелика затримка, щоб дати час на оновлення DOM
            setTimeout(() => {
              hideProductPrices();
            }, 100);
          });
        });
      }
    }

    window.onscroll = () => {
      if(document.body.classList.contains('template-product') && window.innerWidth < 1024) {
        if(document.scrollingElement.scrollTop > qs('.product-form-block').offsetTop) {
          qs('.product-single__form.form-fixed').classList.add('active');
        } else {
          qs('.product-single__form.form-fixed').classList.remove('active');
        }
      }
    }
  }

  const okendoReviews = qsa('.product-block [prod-reviews]');
  const reviewsAnchor = qs('#reviews-anchor');

  if (okendoReviews.length && reviewsAnchor) {
    okendoReviews.forEach(el => {
      const wrapper = el.closest('.flex');
      // console.log("🚀 ~ okendoReviews.forEach ~ wrapper:", wrapper)
      // Capture clicks on the star rating itself to override any inner default/link behavior
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const headerHeight = qs('.header') ? qs('.header').offsetHeight : 0;
        scrollTo(offsetTop(reviewsAnchor) - headerHeight);
      }, true);

      if (wrapper) {
        wrapper.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (reviewsAnchor) {
            const headerHeight = qs('.header') ? qs('.header').offsetHeight : 0;
            scrollTo(offsetTop(reviewsAnchor) - headerHeight);
          }
        });
      }
    });
  }



  // collection

  // if(document.body.classList.contains('template-collection')) {
  //   window.onscroll = () => {
      
  //     let to_top = qs('#to_top');
  //     if(document.scrollingElement.scrollTop > window.innerHeight) {
  //       to_top.classList.remove('hiddn');
  //     } else {
  //       to_top.classList.add('hiddn'); 
  //     }
  
  //     to_top.onclick = () => {
  //       scrollTo(offsetTop(qs('#CollectionAjaxContent')));
  //     }
  //   }
  // }



  // brands
  qsaEach('.all-brands-btn', 0, (el) => {
    el.onclick = () => {
      localStorage.setItem('show-all-brands', 'true');  
    }
  })



  let brands = qsa('.brands__block');
  let brands_nav = qs('.brands__nav');

  let headerHeight = document.querySelector('header.header').offsetHeight;
  
  if(brands_nav) {
    qs('.brands__nav .btn').onclick = (e) => {

      if(brands_nav.classList.contains('active')) {
        brands_nav.classList.remove('active');
      } else {
        brands_nav.classList.add('active');
      }
    };

    brands.forEach(el => {
      if(!qs('.flex', el).childElementCount) {
        let anchor = el.querySelector('span').innerHTML;
        qs('[data-anchor="' + anchor + '"]').style.display = 'none';
  
        el.style.display = 'none';
      }
    });

    window.onscroll = () => {
      for(let i = 0; i < brands.length; i++) {
        let el = brands[i];
    
        if(el.getBoundingClientRect().top - qs('.brands__nav').clientHeight - headerHeight < 30 &&
           el.getBoundingClientRect().bottom - qs('.brands__nav').clientHeight - headerHeight > 30) {
    
          let anchor = el.querySelector('span').innerHTML;
          qsa('a[data-anchor]').forEach(elem => elem.classList.remove('active'));
    
          qs('[data-anchor="' + anchor + '"]').classList.add('active');
    
          break;
        }
      }
    }
  }
  qsa('a[data-anchor]').forEach(el => {
    el.onclick = (e) => {
      e.preventDefault();
  
      let scrollToY;

      if(el.dataset.anchor == '#') {
        scrollToY = offsetTop(qs('#char')) - qs('.brands__nav').clientHeight - headerHeight;
      } else {
        scrollToY = offsetTop(qs('#' + el.dataset.anchor)) - qs('.brands__nav').clientHeight - headerHeight;
      }
  
      scrollTo(scrollToY);
    }
  })
  
  qsaEach('.shops__btn', 0, (el) => {
    el.onclick = () => {
      qs('.bxe_book_button', el.closest('div')).click();
    }
  })

  
  const scrollRaf = window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame;
  
  function scrollTo(to) {
    const start = window.scrollY || window.pageYOffset;
    const time = Date.now();
    const duration = Math.abs(start - to) / 2;
  
    (function step() {
      var dx = Math.min(1, (Date.now() - time) / duration)
      var pos = start + (to - start) * easeInOutCubic(dx)
  
      window.scrollTo(0, pos)
  
      if (dx < 1) {
        scrollRaf(step);
      }
    })()
  }
  function easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  }
  function offsetTop(el) {
    var rect = el.getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }
  
  
  if(document.body.classList.contains('template-collection')) {
    if(localStorage.getItem('show-all-brands') == 'true') {
      scrollTo(offsetTop(qs('#CollectionAjaxContent')));
    }
  }
});




// // setTimeout(()=> {
//   // var klScripts = ["https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=VwRtRs"];

//   // klScripts.forEach(url => {
//   //   var asyncScript = document.createElement('script');
//   //   asyncScript.defer = true;
//   //   asyncScript.src = url;
//   //   document.body.appendChild(asyncScript);
//   // });

  // (function(d, s, id) {
  //   var js, fjs = d.getElementsByTagName(s)[0];
  //   if (d.getElementById(id))
  //       return;
  //   js = d.createElement(s);
  //   js.id = id;
  //   js.src = "https://connect.facebook.net/fr_CA/sdk/xfbml.customerchat.js#xfbml=1&version=v2.12&autoLogAppEvents=1";
  //   fjs.parentNode.insertBefore(js, fjs);
  // }(document, "script", "facebook-jssdk"));

  // var show_customer_chat = "<div class='fb-customerchat' page_id='150011995094648' ref='' theme_color='#000000' logged_in_greeting='Bonjour, comment pouvons-nous vous aider? / Hi, How can we help you?' greeting_dialog_display='hide'></div>";
  // var chat = document.createElement('div');
  // chat.dataset.chat=true;
  // chat.innerHTML = show_customer_chat;
  // document.body.append(chat);
  // $("<style></style>").appendTo("head").html(".fb_dialog, .fb-customerchat:not(.fb_iframe_widget_fluid) iframe{margin-bottom:0px !important;}");

// }, 3000)
